// @flow

import * as browserEnv from '../browserEnv'
import * as analysis from '../analysis/index'
import { delayPromise } from '../promise'

function appShareAnalytics (opts) {
  let suc = opts.success
  let failure = opts.failure

  opts.success = getFnName(function () {
    suc && suc instanceof Function && suc()
    analysis.trackEventValue('app-share-success', {
      url: opts.link
    })
  })
  opts.failure = getFnName(function () {
    failure && failure instanceof Function && failure()
    analysis.trackEventValue('app-share-cancel', {
      url: opts.link
    })
  })
}

function getFnName (callback?: Function): string {
  let fnName =
    'fn_' + parseInt(Math.random() * 10000, 10) + '_' + new Date().getTime()
  window[fnName] = typeof callback === 'function' ? callback : function () {}
  return fnName
}

let readyNum = 0

function ready () {
  if (window.FengjrApp) {
    return Promise.resolve()
  } else if (readyNum > 10) {
    return Promise.reject(new Error('no window.FengjrApp'))
  }
  readyNum++
  return delayPromise(200).then(() => ready())
}

function isAvailable (fnName) {
  return !!(window.FengjrApp && window.FengjrApp[fnName])
}

type ShareInfo = {
  title: string,
  imgUrl: string,
  desc: string,
  link: string,
  failure?: () => void,
  success?: () => void
};
function share (shareInfo: ShareInfo) {
  let opts = { ...shareInfo }
  ready().then(() => {
    appShareAnalytics(opts)
    if (browserEnv.isInAndroidApp()) {
      window.FengjrApp.share(JSON.stringify(opts))
    } else if (browserEnv.isInIOSApp()) {
      window.FengjrApp.share(opts)
    }
  })
}

function baixinSuccess (bxInfo: Object) {
  ready().then(() => {
    appShareAnalytics(bxInfo || {})
    if (browserEnv.isInAndroidApp()) {
      window.FengjrApp.baixinSuccess(JSON.stringify(bxInfo || {}))
    } else if (browserEnv.isInIOSApp()) {
      window.FengjrApp.baixinSuccess(bxInfo || '')
    }
  })
}

function baixinError (bxInfo: Object) {
  ready().then(() => {
    appShareAnalytics(bxInfo || {})
    if (browserEnv.isInAndroidApp()) {
      window.FengjrApp.baixinError(JSON.stringify(bxInfo || {}))
    } else if (browserEnv.isInIOSApp()) {
      window.FengjrApp.baixinError(bxInfo || '')
    }
  })
}

function showShareButton (shareInfo: ShareInfo) {
  let opts = { ...shareInfo }
  if (/^[/][/]/.test(opts.imgUrl)) {
    opts.imgUrl = opts.imgUrl.replace(/^[/][/]/, 'http://')
  }
  ready().then(() => {
    setTimeout(() => {
      appShareAnalytics(opts)
      if (browserEnv.isInAndroidApp()) {
        window.FengjrApp.showShareButton(JSON.stringify(opts))
      } else if (browserEnv.isInIOSApp()) {
        window.FengjrApp.showShareButton(opts)
      }
    }, 200)
  })
}

function hiddenShareButton () {
  setTimeout(() => {
    try {
      window.FengjrApp.hiddenShareButton()
    } catch (e) {}
  }, 100)
}

function getUser (callback: Function) {
  ready().then(() => {
    window.FengjrApp.getUser(getFnName(callback))
  })
}

function login (success: Function, cancel?: Function) {
  getUser(function (userinfo) {
    if (userinfo.isLogin) {
      return success()
    }
    if (typeof cancel === 'function') {
      window.FengjrApp.login(getFnName(success), getFnName(cancel))
    } else {
      window.FengjrApp.login(getFnName(success))
    }
  })
}

function selectAddress (callback: Function) {
  if (isAvailable('selectAddress')) {
    window.FengjrApp.selectAddress(getFnName(callback))
  }
}

function register (callback: Function) {
  window.FengjrApp.showRegister(getFnName(callback))
}

function toPageRouter (path: string, replace?: boolean) {
  ready().then(() => {
    let origin
    if (/^http(s)?:\/\//.test(path) || /^(fengjr|magpie):\/\//.test(path)) {
      origin = ''
    } else if (browserEnv.isInXqkdApp()) {
      origin = 'magpie://'
    } else {
      origin = 'fengjr://'
    }
    let routerOpts = { url: origin + path, finish: !!replace }
    if (browserEnv.isInAndroidApp()) {
      isAvailable('toPageRouter') &&
        window.FengjrApp.toPageRouter(JSON.stringify(routerOpts))
    } else if (browserEnv.isInIOSApp()) {
      isAvailable('toPageRouter') && window.FengjrApp.toPageRouter(routerOpts)
    }
  })
}

function setPageTitle (title: string) {
  ready().then(() => {
    isAvailable('setPageTitle') && window.FengjrApp.setPageTitle(title)
  })
}

type TitleInfo = {
  show: boolean,
  text: string,
  url: string
};
function toggleActionBarRightTitle (titleInfo: TitleInfo) {
  ready().then(() => {
    if (browserEnv.isInAndroidApp()) {
      isAvailable('toggleActionBarRightText') &&
        window.FengjrApp.toggleActionBarRightText(JSON.stringify(titleInfo))
    } else if (browserEnv.isInIOSApp()) {
      isAvailable('toggleActionBarRightText') &&
        window.FengjrApp.toggleActionBarRightText(titleInfo)
    }
  })
}

type NavBarConfig = {
  text: string,
  image: string,
  clickCallback: Function
};

function setNavigationBarRightButton (navBarConfig: NavBarConfig) {
  ready().then(() => {
    if (browserEnv.isInAndroidApp()) {
      if (isAvailable('setNavigationBarRightButton')) {
        window.FengjrApp.setNavigationBarRightButton(
          JSON.stringify({
            text: navBarConfig.text,
            image: navBarConfig.image,
            clickCallback: getFnName(navBarConfig.clickCallback)
          })
        )
      } else if (
        isAvailable('toggleActionBarRightText') &&
        isAvailable('setActionBarRightClickCallback')
      ) {
        window.FengjrApp.toggleActionBarRightText(
          JSON.stringify({
            show: true,
            text: navBarConfig.text
          })
        )
        window.FengjrApp.setActionBarRightClickCallback(
          getFnName(navBarConfig.clickCallback)
        )
      }
    } else if (browserEnv.isInIOSApp()) {
      if (isAvailable('setNavigationBarRightButton')) {
        window.FengjrApp.setNavigationBarRightButton({
          text: navBarConfig.text,
          image: navBarConfig.image,
          clickCallback: getFnName(navBarConfig.clickCallback)
        })
      } else if (
        isAvailable('toggleActionBarRightText') &&
        isAvailable('setActionBarRightClickCallback')
      ) {
        window.FengjrApp.toggleActionBarRightText({
          show: true,
          text: navBarConfig.text
        })
        window.FengjrApp.setActionBarRightClickCallback(
          getFnName(navBarConfig.clickCallback)
        )
      }
    }
  })
}

function getSessionInfo (
  callback: (sessionInfo: ?{ seq: number, session_id: string }) => void
) {
  ready().then(() => {
    if (!isAvailable('getSessionInfo')) {
      return callback(null)
    }
    window.FengjrApp.getSessionInfo(getFnName(callback))
  })
}

function closeToRoot () {
  ready().then(() => {
    if (isAvailable('closeCurrentPushPage')) {
      window.FengjrApp.closeCurrentPushPage({})
    }
  })
}

function closeLeftGesture () {
  ready().then(() => {
    if (isAvailable('closeLeftGesture')) {
      window.FengjrApp.closeLeftGesture({})
    }
  })
}

function hideBackIcon () {
  ready().then(() => {
    if (isAvailable('hideBackIcon')) {
      window.FengjrApp.hideBackIcon({})
    }
  })
}

function showBackIcon () {
  ready().then(() => {
    if (isAvailable('showBackIcon')) {
      window.FengjrApp.showBackIcon({})
    }
  })
}

function openThirdPartyApps (linkUrl: string) {
  ready().then(() => {
    window.FengjrApp.openThirdPartyApps(linkUrl)
  })
}

function nativeCopy (copyText: string) {
  ready().then(() => {
    window.FengjrApp.nativeCopy(copyText)
  })
}

function close () {
  return window.FengjrApp && window.FengjrApp.closeCurrentPage('fuck')
}

type CalendarEventOPts = {
  title: string,
  description: string,
  url: string,
  eventStartTime: number,
  eventEndTime: number,
  alarmTime: number
};
function addCalendarEvent (opts: CalendarEventOPts, callback: Function) {
  ready().then(() => {
    if (isAvailable('addCalendarEvent')) {
      if (browserEnv.isInAndroidApp()) {
        window.FengjrApp.addCalendarEvent(
          JSON.stringify(opts),
          getFnName(callback)
        )
      } else if (browserEnv.isInIOSApp()) {
        window.FengjrApp.addCalendarEvent(opts, getFnName(callback))
      }
    } else {
      return callback(new Error('not support'))
    }
  })
}

function getAppInfo (callback: Function) {
  ready().then(() => {
    if (isAvailable('getAppInfo')) {
      window.FengjrApp.getAppInfo(getFnName(callback))
    } else {
      return callback(null)
    }
  })
}

type GoBackAction = {
  isInterception: boolean,
  callBack: Function
};

function getNavLeftGoBackAction (goBackAction: GoBackAction) {
  let opts = { ...goBackAction }
  opts.callBack = getFnName(goBackAction.callBack)
  ready().then(() => {
    if (browserEnv.isInAndroidApp()) {
      window.FengjrApp.getNavLeftGoBackAction(JSON.stringify(opts))
    } else if (browserEnv.isInIOSApp()) {
      window.FengjrApp.getNavLeftGoBackAction(opts)
    }
  })
}

function goBack () {
  ready().then(() => {
    if (browserEnv.isInAndroidApp()) {
      window.FengjrApp && window.FengjrApp.goBack()
    } else if (browserEnv.isInIOSApp()) {
      window.FengjrApp && window.FengjrApp.goBack('')
    }
  })
}

function restoreGoBack () {
  if (!browserEnv.isInApp()) return
  getNavLeftGoBackAction({
    isInterception: false,
    callBack: () => {}
  })
}

function sharePageToWeixin () {
  ready().then(() => {
    isAvailable('sharePageToWeixin') && window.FengjrApp.sharePageToWeixin()
  })
}

type Message = {
  type: string,
  value: any,
};

function message (msg: Message) {
  ready().then(() => {
    if (browserEnv.isInAndroidApp()) {
      isAvailable('message') &&
      window.FengjrApp.message(JSON.stringify(msg))
    } else if (browserEnv.isInIOSApp()) {
      isAvailable('message') &&
      window.FengjrApp.message(msg)
    }
  })
}

export {
  getAppInfo,
  addCalendarEvent,
  close,
  closeToRoot,
  toggleActionBarRightTitle,
  setNavigationBarRightButton,
  getSessionInfo,
  setPageTitle,
  toPageRouter,
  register,
  selectAddress,
  hiddenShareButton,
  login,
  showShareButton,
  share,
  getUser,
  goBack,
  getNavLeftGoBackAction,
  closeLeftGesture,
  hideBackIcon,
  showBackIcon,
  sharePageToWeixin,
  restoreGoBack,
  baixinSuccess,
  baixinError,
  openThirdPartyApps,
  nativeCopy,
  message
}



// WEBPACK FOOTER //
// ./src/frame/core/app/fengjr.js